// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__0j07k","tail":"styles_tail__hw3FK","main":"styles_main__1BYOR"};